import angular from 'angular';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';

const componentOptions = {
    bindings: {
        price: '=',
        selected: '=',
        modules: '=',
        view: '=',
        dataequalrow: '=',
        available: '=',
        index: '=',
        last: '='
    },
    controllerAs: 'ibInsuranceAllianzFusionBoxCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-insurance-allianz-fusion-box-view.html';
    }]
};


const componentInfo = {
    module: 'ib-insurance-allianz-fusion-box-module',
    selector: 'ibInsuranceAllianzFusionBox',
    inject: ['$rootScope', '$scope', 'DatalayerUtils', 'localStorageService'],
    required: ['']
};


export class ibInsuranceAllianzFusionBox implements ng.IController {
    public insuranceIsSelected;

    constructor (
        private $rootScope: angular.IRootScopeService,
        private $scope: angular.IScope,
        private DatalayerUtils: DatalayerUtils,
        private localStorageService: angular.local.storage.ILocalStorageService) {

        this.$rootScope.$on('updateInsuranceSelectedStatus', this.updateInsuranceSelectedStatus);
        this.insuranceIsSelected = this.localStorageService.get('allianzFusionSelected');
    }
    updateInsuranceSelectedStatus = (event: angular.IAngularEvent, isSelected: boolean): void => {
        this.insuranceIsSelected = isSelected;
    };
    /**
     * Emit event to parent for open modal of insurance
    */
    openInsuranceModal = (): void => {
        this.DatalayerUtils.getAncillariesDigitalDataEcommerce('insurance', 'view_item_list');
        this.$scope.$emit('openInsuranceAllianzFusionModal');
    };

}

try {
    const mod = angular.module(componentInfo.module);
    ibInsuranceAllianzFusionBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibInsuranceAllianzFusionBox })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibInsuranceAllianzFusionBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibInsuranceAllianzFusionBox })
    );
}